// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"d5a5227b","348":"a45aea28","367":"38f934a1","488":"17fb8a7b","575":"4eae2172","617":"71dc4aad","795":"d1988086","913":"7aeaed55","927":"c2d37288"}[chunkId] + ".chunk.css";
};